import {
  GLHeaderNavListItemProps,
  useI18n,
} from '@group-link-one/grouplink-components';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth, useGLFlags } from '@group-link-one/gl-utils';
import { usePrivileges } from '../hooks/usePrivilleges';

export enum SettingsRoutes {
  DEFAULT = '/settings',
  OVERVIEW = '/settings/overview',
  MY_ACCOUNT = '/settings/my-account',
  LOGIN_SECURITY = '/settings/login-security',
}

type TypeLayout = 'settings';

interface PageLayout {
  getHeaderNavList: (type: TypeLayout) => GLHeaderNavListItemProps[];
}

export function usePageLayout(): PageLayout {
  const { t } = useI18n();
  const { flags } = useGLFlags();
  const { pages } = usePrivileges();
  const navigate = useNavigate();

  const settings: GLHeaderNavListItemProps[] = useMemo(() => {
    const items: GLHeaderNavListItemProps[] = [
      {
        id: 1,
        title: t('pages.deviceOverview.overview'),
        path: SettingsRoutes.OVERVIEW,
        isToAppear: pages.settings.overview,
        onClick: () => navigate(SettingsRoutes.OVERVIEW),
      },
      {
        id: 2,
        title: t('pages.settings.myAccount'),
        path: SettingsRoutes.MY_ACCOUNT,
        isToAppear: pages.settings.myAccount,
        onClick: () => navigate(SettingsRoutes.MY_ACCOUNT),
      },
      {
        id: 3,
        title: t('pages.settings.loginSecurity'),
        path: SettingsRoutes.LOGIN_SECURITY,
        isToAppear: pages.settings.loginSecurity,
        onClick: () => navigate(SettingsRoutes.LOGIN_SECURITY),
      },
    ];

    return items.filter((item) => item.isToAppear);
  }, [flags, pages.settings]);

  function getHeaderNavList(type: TypeLayout): GLHeaderNavListItemProps[] {
    switch (type) {
      case 'settings':
        return settings;
      default:
        return [];
    }
  }

  return {
    getHeaderNavList,
  };
}
